var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"toptitle":"Plattform bearbeiten","name":"settings-workspace-platform-edit","title":_vm.platform.label,"width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('SettingsWorkspacePlatformForm',{attrs:{"platform":_vm.platform,"index":_vm.index,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }